import { render } from "./ChallengeUserboard.vue?vue&type=template&id=ba7544ea&scoped=true"
import script from "./ChallengeUserboard.vue?vue&type=script&lang=js"
export * from "./ChallengeUserboard.vue?vue&type=script&lang=js"

import "@/css/components/challenge-userboard.css?vue&type=style&index=0&id=ba7544ea&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7544ea"]])

export default __exports__